import createReducer from '../createReducer';
import {TAiAgent} from './aiAgent.type';

const initialState: TAiAgent = {
    isOpen: false,
    sessionEventType: null,
    sessionIntent: null,
    chatLang: null,
    openTicketPopupRequestId: 0,
    currentFormValues: null,
    pendingFormFill: null,
    activeFormId: null,
    clearingFeeAcknowledged: false,
    sendMessageXHR: null,
};

export default createReducer('aiAgent', initialState);
